import { service } from "../../../services";

const state = {
  error: null,
  loading: false
};

const mutations = {
  setTiles(state, tiles) {
    state.items = tiles;
  },

  setError(state, error) {
    state.error = error;
  },

  setLoading(state, loading) {
    state.loading = loading;
  }
};

const actions = {
  async fetchTiles({ commit }, category) {
    try {
      let res = await service.get("/tiles?category=" + category);
      return res.items;
    } catch (err) {
      console.log(err.message);
    }
  }
};

export const tiles = {
  namespaced: true,
  state,
  mutations,
  actions
};
